if (!customElements.get('adev-new-article')) {
    customElements.define('adev-new-article', class adevNewArticle extends HTMLElement {
        constructor() {
            super();

            this.tableOfContents = [];
        }

        initTableOfContents(){
            const contentEl = this.querySelector('[data-adev-new-article="content"]');
            const headings = contentEl.querySelectorAll('h2, h3, h4');
            headings.forEach(heading => {
                const id = heading.id || heading.textContent.trim().toLowerCase().replace(/\s+/g, '-');
                heading.id = id;
                this.tableOfContents.push({ id, title: heading.textContent });
            });

            const mainListEl = this.querySelector('[data-adev-new-article="toc-main-list"]');

            const markup = this.querySelector('[data-adev-new-article="toc-item-markup"]').innerHTML;
            const sideListEl = this.querySelector('[data-adev-new-article="toc-list"]');
            
            this.tableOfContents.forEach((item, index) => {
                if (mainListEl && index > 0) {
                    const mainListItem = document.createElement('li');
                    mainListItem.innerHTML = `<a href="#${item.id}">${item.title}</a>`;
                    mainListEl.appendChild(mainListItem);
                }

                const listItem = document.createElement('li');
                listItem.innerHTML = `${markup} <a href="#${item.id}">${item.title}</a>`;
                sideListEl.appendChild(listItem);
            });
        }

        connectedCallback() {
            this.initTableOfContents();
        }

        disconnectedCallback() {
            
        }

    });
}